// Module
var code = "<script>let $input</script> <molecule-form-drop-down model=\"$input.value\" items=\"$input.selectionOptions\" button-modifier=\"thinner\" callback-on-change=\"$input.changed\"></molecule-form-drop-down> ";
// Exports
module.exports = code;